import 'date-fns';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { format as formatDate, parse } from 'date-fns';

const DatePickerComponent = (props) => {
  // Extract the required props, with default values
  const { value = null, format = 'dd/MM/yyyy', onChange } = props;

  // Initial value setup using date-fns parsing
  const initialDate = value ? parse(value, format, new Date()) : null;

  const handleDateChange = (date) => {
    const formattedDate = date ? formatDate(date, format) : null;
    const event = {
      target: {
        value: formattedDate,
      },
    };
    onChange(event);  // Pass the formatted date back through the onChange prop
  };

  let label = 'Select Year, Month & Date';
  let viewCalendarFormat = ['year', 'month', 'date'];

  if (format) {
    switch (format) {
      case 'yyyy/MM/dd':
        label = 'Select Year, Month & Date';
        viewCalendarFormat = ['year', 'month', 'date'];
        break;
      case 'yyyy/MM':
        label = 'Select Year & Month';
        viewCalendarFormat = ['year', 'month'];
        break;
      default:
        label = 'Select Year, Month & Date';
        viewCalendarFormat = ['year', 'month', 'date'];
    }
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justifyContent="space-around">
        <KeyboardDatePicker
          disableToolbar
          variant="inline"
          format={format}
          margin="normal"
          label={label}
          value={initialDate}
          onChange={handleDateChange}
          views={viewCalendarFormat}            autoOk 
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
      </Grid>
    </MuiPickersUtilsProvider>
  );
};

export default DatePickerComponent;
